import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { EsgLogo as EsgLogo$2 } from './style.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["className", "esgType", "onClick", "alt", "lazy", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getEsgLogoSettings = function getEsgLogoSettings(type, size, alt) {
  var checkedType = type ? type.toLowerCase() : '';
  switch (checkedType) {
    case 'landscape':
      {
        return {
          name: 'landscape',
          url: '/web/esg/esg-landscape-logo',
          desktopSize: size.desktop || 108,
          mobileSize: size.mobile || 80,
          altText: alt || 'ESG Certified'
        };
      }
    case 'square':
      {
        return {
          name: 'square',
          url: '/web/esg/esg-square-logo',
          desktopSize: size.desktop || 32,
          mobileSize: size.mobile || 32,
          altText: alt || 'ESG'
        };
      }
    case 'excursion':
      {
        return {
          name: 'excursion',
          url: '/web/esg/esg-excursion-logo',
          desktopSize: size.desktop || 153,
          mobileSize: size.mobile || 113,
          altText: alt || 'ESG Travel with care excursion'
        };
      }
    case 'portrait':
    default:
      {
        return {
          name: 'portrait',
          url: '/web/esg/esg-portrait-logo',
          desktopSize: size.desktop || 30,
          mobileSize: size.mobile || 30,
          altText: alt || 'ESG Certified'
        };
      }
  }
};

/**
 * Renders the EsgLogo component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} [props.className=null] - The class name for the component.
 * @param {'landscape'|'square'|'excursion'|'portrait'} [props.esgType='portrait'] - The type of EsgLogo to render.
 * @param {React.MouseEventHandler<HTMLDivElement>} [props.onClick=null] - The click event handler for the component.
 * @param {string} [props.alt=null] - The alt text for the image.
 * @param {boolean} [props.lazy=false] - Whether to lazy load the image.
 * @param {{desktop: number, mobile: number}} [props.size={ desktop: null, mobile: null } ] - The size configuration for the EsgLogo.
 * @param {Object} [props.rest] - The remaining props for the component.
 * @returns {JSX.Element|boolean} The rendered EsgLogo component.
 */
var EsgLogo = function EsgLogo(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    _ref$esgType = _ref.esgType,
    esgType = _ref$esgType === void 0 ? 'portrait' : _ref$esgType,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? null : _ref$alt,
    _ref$lazy = _ref.lazy,
    lazy = _ref$lazy === void 0 ? false : _ref$lazy,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? {
      desktop: null,
      mobile: null
    } : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  var esgLogoSettings = getEsgLogoSettings(esgType, size, alt);
  if (!esgType || !esgLogoSettings) {
    return false;
  }
  return /*#__PURE__*/jsx(EsgLogo$2, _objectSpread(_objectSpread({
    className: className,
    onClick: onClick
    // @ts-ignore
    ,
    $desktopSize: esgLogoSettings.desktopSize,
    $mobileSize: esgLogoSettings.mobileSize
  }, rest), {}, {
    children: /*#__PURE__*/jsx("img", {
      loading: lazy ? 'lazy' : 'eager',
      src: "//img.nltg.com/image/upload".concat(esgLogoSettings.url, ".svg"),
      alt: esgLogoSettings.altText
    })
  }));
};
var EsgLogo$1 = EsgLogo;

export { EsgLogo$1 as default };
//# sourceMappingURL=EsgLogo.js.map
